"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "journey-bg", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }), (0, jsx_runtime_1.jsx)("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "journey-header", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-header-background", children: (0, jsx_runtime_1.jsx)("a", { className: "header-logo-link", id: "goTo".concat(services_1.resourcesHelper.THEME, "HomePage"), href: services_1.resourcesHelper.BRAND_URL, target: "_blank", "aria-label": "Link to ".concat(services_1.resourcesHelper.THEME, " home page"), children: (0, jsx_runtime_1.jsx)("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo icon"), tabIndex: 0 }) }) }) })] }));
    };
    return Header;
}(React.Component));
exports.Header = Header;
//# sourceMappingURL=Header.js.map